import React, { useState } from 'react';
import { useQuery } from './QueryContext';
import config from '../utils/config.json';

import {Paper, Box, Typography, useTheme, Grid2} from '@mui/material';
import { Button, TextArea, ArrowUpIcon } from './ui';

import '../styles/bottombar.css';


function Query(props) {
    const language = props.language

    const [localQuery, setLocalQuery] = useState('');
  
    // // Handler for Change
    const handleChange = event => {
        setLocalQuery(event.target.value);
        autoResizeTextarea(event.target);
    };

    // Function to auto resize text area
    const autoResizeTextarea = textarea => {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
    };

    // Handler for Key Down
    // const handleKeyDown = event => {
    //     if (event.key === "Enter") {
    //         // console.log('onKeyDown=Enter');
    //         event.preventDefault();

    //         // Broadcast the change to our QueryContext listeners...
    //         onChange(event.target.value.trim());

    //         // Erase contents of the input control...
    //         setLocalQuery('');
    //     }
    // };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault(); // Prevents the default action of adding a new line
          submitQuery();
        }
      };

    const submitQuery = () => {
        if (localQuery.trim() !== '') {
            onChange(localQuery.trim());
            setLocalQuery('');
        }
    };

    // Get the function handler for us to communicate a change in QueryContext to any listeners
    const { onChange } = useQuery();

    return (
        <Paper sx={{ backgroundColor: 'transparent', boxShadow: 0 }} className="bottom-bar" square>
            <Box width={1145}>
                <Box sx={{
                    backgroundColor: '#fff',
                    border: '1.5px solid #330000',
                    borderRadius: '12px',
                    boxShadow: '0 2px 12px rgba(51,0,0,0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 1.5,
                    py: 1,
                }}>
                        <Box sx={{ flex: 1 }}>
                            <TextArea
                                placeholder={config.languages.find(lang => lang.code === language)?.texts.message}
                                rows={2}
                                size="large"
                                onChange={handleChange}
                                onKeyDown={handleKeyDown}
                                value={localQuery}
                                disabled={props.disabled}
                                sx={{ '& fieldset': { border: 'none' } }}
                            />
                        </Box>
                        <Button
                            aria-label="Submit"
                            icon={<ArrowUpIcon strokeWidth={2} />}
                            onClick={submitQuery}
                            size="large"
                            variant="primary"
                            disabled={props.disabled}
                            sx={{
                                backgroundColor: '#E20000',
                                color: '#fff',
                                '&:hover': { backgroundColor: '#B30000' },
                                minWidth: 0,
                                width: '44px',
                                height: '44px',
                                padding: 0,
                            }}
                        />
                </Box>

                <Box sx={{ textAlign: 'center', pt: 1 }}>
                    <Typography style={{ fontSize: '10px', color: '#5c5b5b' }}>
                        {config.languages.find(lang => lang.code === language).texts.legalshort}
                        {' • '}
                        {config.languages.find(lang => lang.code === language).texts.honeywell} {config.languages.find(lang => lang.code === language).texts.rights}
                    </Typography>
                    <Typography style={{ fontSize: '10px', color: '#3366CC' }}>
                        <a href={config.privacy_statement_url} target="_blank" rel="noopener noreferrer">
                            {config.languages.find(lang => lang.code === language).texts.privacynotice}
                        </a>
                        {' • '}
                        {config.languages.find(lang => lang.code === language).texts.eulanotice}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
}

export default Query;